<template>
    <section class="app-main">
        
        <el-card class="m-bottom-4" style="padding:15px">
            <el-row  class="user-info">
                <p class="user">当前用户：
                    <el-tag>{{user.nickname}}</el-tag>
                </p>
                <p class="user">权限角色：
                    <el-tag>技术开发</el-tag>
                    <el-tag type="success">商品管理</el-tag>
                    <el-tag type="info">订单管理</el-tag>
                    <el-tag type="warning">售后管理</el-tag>
                    <el-tag type="danger">订货管理</el-tag>
                </p>
 
            </el-row>
  
         
        </el-card>

        <el-card class="user-timeline">
            <el-timeline style="height:100%">
                <el-timeline-item v-for="(it, index) in tableData" :key="index" :timestamp="it.updated_at" placement="top">
                    <el-card style="padding:8px 15px">
                        <p class="user">用户：{{it.uid_info}}</p>
                        <p class="user">地址：{{it.ip}}</p>
                        <p class="user">描述：{{it.describe}}</p>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </el-card>
        
    </section>
</template>


<script>
import { actionlog } from '@/api/home.js'
import { mapState  } from 'vuex'
export default {
    data() {
        return {
            tableData: [],
            page:1,
            size:20,
            total:0,
            tags: [
                { name: '开发者', type: '' },
                { name: '商品管理者', type: 'success' },
                { name: '订单管理者', type: 'info' },
                { name: '售后管理者', type: 'warning' },
                { name: '订货管理者', type: 'danger' }
            ],

            img: { url: '', pic_id: '' }
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            let params = {
                page:this.page
            }
            actionlog(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            })
        },
    },
    computed:{
        ...mapState([ 'meau' , 'user']),
    },
    created(){
        this.handleData();
        this.$store.dispatch('getUser')
    },
    
    activated() {
        this.handleData()
    }
}
</script>

<style lang="less" scoped>
section{
    .describe{
        font-size: 14px;
        font-weight: 400;
        color: #1f2f3d;
        margin: 19px 0;
    }
    .user {
        font-size: 14px;
        color: #5e6d82;
        line-height: 1.5em;
        margin:14px 0;
    }
    .user-info {
       
        height: 45%;
        /deep/ .el-tag + .el-tag {
            margin-left: 15px;
        }
    }
    .user-timeline {
        height: 55%;
        overflow-y: auto;
        padding: 8px 15px;
    }
}
</style>